import React, { ReactNode, useRef, useState } from "react";

import { InputBaseProps } from "@mui/material";

import { limitTwoDecimals } from "@utility/utilityFunctions";
import { moneyValidation } from "@utils/forms";
import { StyledTextInput } from "@utils/forms/ControlledInputs";

const DebounceTextField = React.memo(
  ({
    value: initialValue,
    handleSave,
    isNumberOnly,
    ...props
  }: {
    value: any;
    handleSave: (value: string) => void;
    isNumberOnly?: boolean;
    label?: ReactNode;
  } & Omit<InputBaseProps, "ref">) => {
    const [value, setValue] = useState(initialValue || "");
    const debounceRef = useRef<null | NodeJS.Timeout>(null);

    const save = (value, delay = 750) => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        if ((initialValue ?? "") === value) return;
        handleSave(isNumberOnly ? cleanNumberString(value) : value);
      }, delay);
    };

    const handleChange = (value) => {
      if (isNumberOnly) {
        value = moneyValidation.transform(value);
      }
      setValue(value);
      if (isNumberOnly) {
        value = limitTwoDecimals(value);
      }
      save(value);
    };

    const handleBlur = (value) => {
      if (isNumberOnly) {
        value = limitTwoDecimals(cleanNumberString(value));
      }
      setValue(value);
      save(value, 0);
    };

    const cleanNumberString = (value) => {
      return value.replace(/,/g, "");
    };

    return (
      <StyledTextInput
        value={value}
        onChange={(evt) => handleChange(evt.target.value)}
        onBlur={(evt) => handleBlur(evt.target.value)}
        {...props}
      />
    );
  }
);

export default DebounceTextField;
